module.exports = "<div class=swiper-container> <div class=swiper-wrapper ng-transclude></div> </div> <div class=swiper-pagination ng-show=$ctrl.hasPagination></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/carousel/carousel.template.html
// module id = 557
// module chunks = 0